<template>
  <header class="site-navbar">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="site-logo col-sm-12 col-lg-6 col-md-4">
          <router-link to="/" class="b" v-if="this.$route.fullPath !== '/'">
            <img
              :src="require('../../public/logo.png')"
              alt
              style="height: 50px; width: 50px"
            />
          </router-link>
          <b-dropdown
            class="float-right dis-sm"
            variant="link"
            no-caret
            right
            no-flip
          >
            <template v-slot:button-content>
              <span style="font-size: 13px; color: white">
                {{ languageFlag.name || getLanguageFlag }}
              </span>
            </template>
            <b-dropdown-text tag="div" style="width: 220px">
              <KTDropdownLanguage
                class="p-2"
                v-on:language-changed="onLanguageChanged"
              ></KTDropdownLanguage>
            </b-dropdown-text>
          </b-dropdown>
        </div>

        <nav class="mx-auto site-navigation">
          <ul class="site-menu js-clone-nav d-none d-xl-block ml-0 pl-0">
            <li v-if="this.$route.path !== '/'">
              <router-link to="/" class="nav-link">
                <a class="navbar-brand logo text-uppercase" href="/">
                  <div class="areaa">{{ $t("annoucement") }}</div>
                </a></router-link
              >
            </li>
          </ul>
        </nav>

        <div
          class="
            right-cta-menu
            text-right
            d-flex
            aligin-items-center
            col-sm-8 col-lg-6 col-md-8
          "
        >
          <div class="ml-xl-auto ml-md-auto style-sm">
            <b-dropdown
              class="float-right dis-lg"
              variant="link"
              toggle-class="btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto"
              no-caret
              right
              no-flip
            >
              <template v-slot:button-content>
                <span style="font-size: 13px; color: white">
                  {{ languageFlag.name || getLanguageFlag }}
                </span>
                <!-- <img
                  v-if="languageFlag"
                  width="20"
                  height="20"
                  class="rounded-sm mr-2 ml-1"
                  :src="
                    languageFlag.lang == 'ru'
                      ? require('@/assets/images/ru.svg')
                      : require('@/assets/images/uz.svg')
                  "
                  alt
                /> -->
              </template>
              <b-dropdown-text tag="div" style="width: 220px">
                <KTDropdownLanguage
                  class="p-2"
                  v-on:language-changed="onLanguageChanged"
                ></KTDropdownLanguage>
              </b-dropdown-text>
            </b-dropdown>
            <!-- <button
              v-if="!token"
              style="z-index: 0"
              @click="$emit('register')"
              class="btn btn-outline-primary pb-2 btn-md text-white btn-sty"
            >
              {{ $t("login.registration") }}
            </button> -->
            <button
              v-if="!token"
              @click="$emit('login')"
              class="
                btn btn-outline-primary
                ml-2
                pb-2
                btn-md
                text-white
                btn-sty
              "
            >
              {{ $t("login.come_out") }}
            </button>
          </div>
          <b-dropdown
            class="text-center"
            v-if="employee || user == 'admin'"
            right
            variant="black"
            toggle-class="header-item"
          >
            <template v-slot:button-content>
              <b-avatar
                v-if="employee"
                :src="
                  employee.employeePhotoUploadPath
                    ? `${baseUrl}/${employee.employeePhotoUploadPath}`
                    : require('@/assets/user.jpg')
                "
              ></b-avatar>
              <span v-if="employee" class="text-white ml-2">{{
                `${employee.username}`
              }}</span>
              <b-avatar
                v-if="user == 'admin'"
                :src="require('@/assets/user.jpg')"
              ></b-avatar>
              <span v-if="user == 'admin'" class="text-white ml-2">{{
                `${user}`
              }}</span>
            </template>
            <!-- item-->
            <b-dropdown-item class="p-0" @click="$router.push('/profile')"
              >{{ $t("employees.profile") }}
            </b-dropdown-item>
            <b-dropdown-item class="p-0" v-if="user == 'admin'">
              <router-link to="/reference/title" style="text-decoration:none">
                {{ $t("references.title") }}
              </router-link>
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>
            <a
              href="#"
              @click.prevent="onLogout"
              class="dropdown-item text-danger"
              >{{ $t("login.come_up") }}</a
            >
          </b-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import i18nService from "@/core/services/i18n.service.js";
import KTDropdownLanguage from "../views/dropdown/DropdownLanguage";

import { mapActions, mapState } from "vuex";

export default {
  watch: {
    isReg: {
      async handler(v) {
        if (!v) {
        }
      },
    },
    isLog: {
      async handler(v) {
        if (!v) {
        }
      },
    },
  },
  data() {
    return {
      isReg: false,
      isLog: false,
      languageFlag: "",
      languages: i18nService.languages,
    };
  },
  components: {
    KTDropdownLanguage,
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("employee", ["getEmployee"]),
    async onLogout() {
      await this.logout();
      localStorage.removeItem("isChangeInformation")
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      });
    },
  },
  computed: {
    ...mapState("auth", ["token"]),
    ...mapState("employee", ["employee", "user"]),
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  },
  mounted(){}
};
</script>

<style>
.areaa {
  text-align: center;
  font-size: 1.4em;
  color: #fff;
  letter-spacing: 0px;
  font-weight: 700;
  text-transform: uppercase;
}

.area {
  text-align: center;
  font-size: 1.4em;
  color: #fff;
  letter-spacing: 0px;
  font-weight: 700;
  text-transform: uppercase;
  animation: blur 1.8s ease-out infinite;
  text-shadow: 0px 0px 1px #fff, 0px 0px 3px #fff;
}

@keyframes blur {
  from {
    text-shadow: 0px 0px 30px #fff, 0px 0px 3px #fff, 0px 0px 6px #fff,
      0px 0px 6px #fff, 0px 0px 6px #fff, 0px 0px 6px #fff, 0px 0px 6px #fff,
      0px 0px 6px #fff, 0px 0px 6px #fff, 0px 0px 6px #fff, 0px 0px 6px #7b96b8,
      0px 0px 20px #7b96b8, 0px 10px 12px #7b96b8, 0px 10px 12px #7b96b8,
      0px 10px 12px #7b96b8, 0px 10px 12px #7b96b8, 0px -10px 12px #7b96b8,
      0px -10px 12px #7b96b8;
  }
}

.dis-sm {
  display: none !important;
  justify-content: space-between;
}

.style-sm {
  display: flex;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 575px) {
  .btn-sty {
    width: 50% !important;
  }

  .dis-sm {
    display: block !important;
  }

  .dis-lg {
    display: none !important;
  }

  .style-sm {
    margin-top: 10px;
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    width: 100%;
  }
}
</style>